export default class RetCode{
    static get SUCCESS(){
        return 0;
    }
    // 没有开始
    static get NOT_OPEN(){
        return 49;
    }

    static get CODE40003(){
        return 40003;
    }

    static get CODE40005(){
        return 40005;
    }

    static get CODE40001(){
        return 40001;
    }

    static get ORG_EXPIRED () { return 143; }
}


// WEBPACK FOOTER //
// ./src/data/RetCode.js